import { render, staticRenderFns } from "./MypagePointExpirationDatePane.vue?vue&type=template&id=05c51b72&scoped=true"
import script from "./MypagePointExpirationDatePane.vue?vue&type=script&lang=ts"
export * from "./MypagePointExpirationDatePane.vue?vue&type=script&lang=ts"
import style0 from "./MypagePointExpirationDatePane.vue?vue&type=style&index=0&id=05c51b72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c51b72",
  null
  
)

export default component.exports